module.exports = __webpack_public_path__ + "img/vision.749adb74.jpg";